const translations = {
  "en": {
    "Altcoin": "Altcoin",
    "Altcoin Season Index": "Altcoin Season Index",
    "Bitcoin": "Bitcoin"
  },
  "zh-tw": {
    "Altcoin": "山寨幣",
    "Altcoin Season Index": "山寨幣熱潮指數",
    "Bitcoin": "比特幣"
  }
};

export default translations;
